var keyMirror = require('keymirror');

module.exports = keyMirror({
    LOGOUT_RESPONSE: null,
    UNAUTHORIZED_EXCEPTION:null
});